import { render, staticRenderFns } from "./sensitiveWord.vue?vue&type=template&id=1a13e735&scoped=true&"
import script from "./sensitiveWord.vue?vue&type=script&lang=js&"
export * from "./sensitiveWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13e735",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a13e735')) {
      api.createRecord('1a13e735', component.options)
    } else {
      api.reload('1a13e735', component.options)
    }
    module.hot.accept("./sensitiveWord.vue?vue&type=template&id=1a13e735&scoped=true&", function () {
      api.rerender('1a13e735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/sensitiveWord.vue"
export default component.exports